import React from 'react';
import {
  analysisDocuments,
  immediateNextSteps,
  keySignals,
  risksAndGaps,
  stateSnapshot,
  steeringDecisions,
} from '../content/stateOfHamroFoolbari';

export default function StateOfHamroFoolbari() {
  return (
    <div className="bg-white py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <section className="mb-12">
          <div className="bg-gray-50 rounded-2xl p-8">
            <div className="flex flex-wrap items-center gap-3 mb-4">
              <span className="inline-flex items-center rounded-full border border-gray-300 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-gray-700">
                Steering Committee Brief
              </span>
              <span className="inline-flex items-center rounded-full bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700">
                Status: {stateSnapshot.status}
              </span>
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
              {stateSnapshot.title}
            </h1>
            <p className="text-lg text-gray-700 mb-2">{stateSnapshot.subtitle}</p>
            <p className="text-sm text-gray-500 mb-6">
              Last updated: {stateSnapshot.updatedOn}
            </p>
            <div className="rounded-xl border border-gray-200 bg-white p-5">
              <p className="text-sm font-semibold text-gray-900 mb-1">
                Recommendation
              </p>
              <p className="text-gray-700">{stateSnapshot.recommendation}</p>
            </div>
          </div>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Key Signals (Dolkha)
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {keySignals.map((signal) => (
              <div
                key={signal.label}
                className="rounded-xl border border-gray-200 bg-white p-5"
              >
                <p className="text-sm font-semibold uppercase tracking-wide text-gray-500 mb-2">
                  {signal.label}
                </p>
                <p className="text-2xl font-bold text-gray-900 mb-2">
                  {signal.value}
                </p>
                <p className="text-sm text-gray-600">{signal.detail}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mb-12">
          <div className="bg-gray-50 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Steering Decisions Needed
            </h2>
            <ol className="space-y-3 text-gray-700">
              {steeringDecisions.map((decision, index) => (
                <li key={decision} className="flex gap-3">
                  <span className="font-semibold text-gray-900">{index + 1}.</span>
                  <span>{decision}</span>
                </li>
              ))}
            </ol>
          </div>
        </section>

        <section className="mb-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="rounded-2xl border border-gray-200 p-6">
              <h2 className="text-xl font-bold text-gray-900 mb-4">
                Risks and Gaps
              </h2>
              <ul className="space-y-3 text-gray-700">
                {risksAndGaps.map((gap) => (
                  <li key={gap}>- {gap}</li>
                ))}
              </ul>
            </div>
            <div className="rounded-2xl border border-gray-200 p-6">
              <h2 className="text-xl font-bold text-gray-900 mb-4">
                Next 30 Days
              </h2>
              <ul className="space-y-3 text-gray-700">
                {immediateNextSteps.map((step) => (
                  <li key={step}>- {step}</li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        <section>
          <div className="bg-gray-50 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Supporting Documents
            </h2>
            <div className="flex flex-wrap gap-3">
              {analysisDocuments.map((doc) => (
                <a
                  key={doc.href}
                  href={`${import.meta.env.BASE_URL}${doc.href}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  {doc.label}
                </a>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
